export enum ViewStateChangeArgType {
  ClientPanStart,
  ClientPanEnd,
  BottomSheetPanelOpened,
  BottomSheetPanelOpening,
  BottomSheetPanelSizeChanged,
  BottomSheetPanelClosing,
}

export class ViewStateChangeArg {
  type: ViewStateChangeArgType;
  bottomSheetPanelHeight?: number;
}
